import { useState } from "react";
import { Link } from 'react-router-dom';
import { reminderDetail } from "../../../pages/api/reminder_detail";
import { useReminderDetail } from "@/api/reminder/useReminderDetail";
import { ReferralIcon, FinancingIcon, ReKYCIcon, InsuranceIcon } from "../../icons";
import { DetailsSidebarCardAccountsSkeleton } from "@/components/account-inventory/skeleton/sidebarSkeleton";
import DetailsSidebarCard from "./detailsOpportunitySidebar";
import InteractionsSidebarCard from "./interactionsOpportunitySidebar";

const SidebarTabsContents =({ showSidebar, setShowSidebar, leadID, oppID, oppType, accName, statusName, product, oppName, hunterID }) => {
    const [activeTab, setActiveTab] = useState('details');
    const [sendLead, setSendLead] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const {contactData, accountOwnsership, reminderData, interactions, interactionsCount, totalPages, isLoading} = useReminderDetail({leadID, page, pageSize});

    const leadSourceLabels = {
        0: "Raw Lead",
        1: "Fresh Lead",
        2: "Profile Completed",
        3: "Meeting Completion",
        4: "Onboarded",
        5: "Activated",
        11: "Tanked",
    };
    const getOpportunityStatus = (status) => {
        const styles = {
            'Raw Lead': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Fresh Lead': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Profile Completed': "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
            'Activated': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Informaton Gathered': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Onboarded': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Collecting Documents': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Compliance Reviewing': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'KYC Approved': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'To Be Re-KYC': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'KYC Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Preparing Quotations': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Pending Selected': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Pending Payment': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Expired': "bg-[#EEEEEE] border-[#EEEEEE] text-[#94A3B8]"
        };
        return styles[status] || "bg-gray-100 text-gray-600";
    };

    return(
        <>
            <div className={`overflow-auto scrollbar-hide flex fixed top-0 right-0 h-full w-screen md:w-[448px] bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
                ${showSidebar ? 'translate-x-0' : 'translate-x-full'}`
            }>
                <div className="px-3 md:px-4 py-2 md:py-3 flex-col border-b justify-between w-full">
                    <div className="flex flex-row justify-between items-center gap-2">
                        <button
                            onClick={() => setShowSidebar(false)}
                            className="w-[44px] h-[44px] md:w-[34px] md:h-[34px] gap-2 px-1 hover:text-gray-700 border rounded-full border-[#1E293B] text-[#1E293B] flex items-center justify-center flex-shrink-0"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 md:w-6 md:h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                            </svg>
                        </button>
                        <Link
                            to={`/opportunity_journey?opp_id=${oppID}&opp_type=${oppType}`}
                            className="w-auto h-auto py-2 px-2 md:px-3 gap-2 rounded-full border border-solid hover:bg-[#E2E8F0] border-[#1E293B] text-[#1E293B] text-xs md:text-sm font-bold whitespace-nowrap"
                        >
                            <span className="hidden sm:inline">View Full Details</span>
                            <span className="sm:hidden">Details</span>
                        </Link>
                    </div>
                    <div className="py-3 md:py-4 px-0 md:px-2 flex flex-col justify-between ">
                        <h3 className="text-[10px] md:text-sm font-bold text-[#94A3B8]">ID-{leadID}</h3>
                        <h1 className='text-base md:text-xl font-bold py-2 md:py-2 break-words'>{accName}</h1>
                        <h3 className="text-xs md:text-sm font-bold text-[#94A3B8] pb-3 md:pb-4 break-words">{oppName}</h3>
                        <div className="flex flex-row gap-2 flex-wrap">
                            <span className="w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-2 md:px-4 gap-2 flex items-center">
                                {product === 'Financing' && <img src={FinancingIcon} alt="Financing" className="w-5 h-5 md:w-6 md:h-6 inline-block"/>}
                                {product === 'Re-KYC' && <img src={ReKYCIcon} alt="Re-KYC" className="w-5 h-5 md:w-6 md:h-6 inline-block" />}
                                {product === 'Insurance' && <img src={InsuranceIcon} alt="Insurance" className="w-5 h-5 md:w-6 md:h-6 inline-block" />}
                                {product === 'Referral' && <img src={ReferralIcon} alt="Referral" className="w-5 h-5 md:w-6 md:h-6 inline-block" />}
                            </span>
                            <span className={`w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-2 md:px-4 gap-2 rounded-full border font-bold text-xs md:text-sm ${getOpportunityStatus(statusName)}`}>
                                {statusName || "Unknown"}
                            </span>
                        </div>
                        <div className="pt-3 md:pt-4 flex justify-between border-b items-center border-gray-200 overflow-x-auto scrollbar-hide cursor-pointer">
                            <a 
                                onClick={() => setActiveTab('details')}
                                className={`flex-1 text-center font-bold pb-2 -mb-[1px] text-xs md:text-base ${activeTab === 'details' ? 'border-b-4 border-[#F7E21E] text-[#1E293B]' : 'text-[#94A3B8]'}`}
                            >
                                Details
                            </a>
                            <a 
                                onClick={() => setActiveTab('interaction')}
                                className={`flex-1 text-center font-bold pb-2 -mb-[1px] text-xs md:text-base whitespace-nowrap ${activeTab === 'interaction' ? 'border-b-4 border-[#F7E21E] text-[#1E293B]' : 'text-[#94A3B8]'}`}
                            >
                                <span className="hidden sm:inline">Interaction History</span>
                                <span className="sm:hidden">Interactions</span>
                            </a>
                        </div>
                        <div className="py-3 md:py-4">
                            {activeTab === 'details' && (
                                isLoading ? (
                                    <DetailsSidebarCardAccountsSkeleton/>
                                ) : (
                                    <div>
                                        <DetailsSidebarCard 
                                        contactData={contactData} 
                                        reminderData={reminderData}
                                        accountOwnership={accountOwnsership}
                                        />
                                    </div>
                                )
                            )}
                            {activeTab === 'interaction' && (
                                <div className='overflow-auto'>
                                    <InteractionsSidebarCard 
                                    interactions = {interactions}
                                    page = {page}
                                    pageSize = {pageSize}
                                    interactionsCount = {interactionsCount}
                                    totalPages = {totalPages}
                                    setPage = {setPage}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div 
                onClick={() => setShowSidebar(false)}
                className={`fixed inset-0 bg-black transition-opacity duration-300 ease-in-out z-40 ${
                showSidebar ? 'opacity-30 visible' : 'opacity-0 invisible'
                }`}
            />
            
        </>
    )
};
export default SidebarTabsContents;